import { InjectionToken } from '@angular/core';

export const BASE_API_URL = new InjectionToken<string>('BASE_API_URL');
